import * as ng from 'angular';
import './alert_modal.html';

export interface IModalFactory {
    showConfirmationModal: (title: string, message: string, okButtonText: string, cancelButtonText: string) => ng.IPromise<any>;
    showAlertModal: (scope: ng.IScope, title: string, message: string, okButtonText: string) => ng.IPromise<any>;
}

angular.module('GorillaBoy')
.factory('ModalFactory', [
    '$log',
    '$uibModal',
    ModalFactory
]);

function ModalFactory($log: ng.ILogService, $uibModal) : IModalFactory {
    return {
        showConfirmationModal : function(title, message, okButtonText, cancelButtonText) {
            var cfg = {
                title: title,
                message: message,
                okButtonText: okButtonText,
                cancelButtonText: cancelButtonText
            };
            var confirmModal = $uibModal.open({
                templateUrl: './shared/confirmation_modal.html',
                controller: ['$scope', function($scope) {
                    $scope.cfg = cfg;
                }],
                size: 'lg'
            });
            return confirmModal.result;
        },

        showAlertModal : function($scope: ng.IScope, title, message, okButtonText) {
            var cfg = {
                title: title,
                message: message,
                okButtonText: okButtonText,
            };
            var confirmModal = $uibModal.open({
                templateUrl: './shared/alert_modal.html',
                controller: ['$scope', function($scope) {
                    $scope.cfg = cfg;
                }],
                size: 'lg'
            });
            $scope.$on('$destroy', () => {
               confirmModal.close();
            });
            return confirmModal.result;
        }
    };
}
